"use strict";

exports.__esModule = true;
var _FontSizePicker = require("./FontSizePicker");
Object.keys(_FontSizePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FontSizePicker[key]) return;
  exports[key] = _FontSizePicker[key];
});